import { Button, Form, Input, Modal, Select, Spin } from "antd"
import TextArea from "antd/lib/input/TextArea";
import { useState } from "react";
import { useIntl } from "react-intl";
import { TranslateString } from "Utils/Common";
import NewLoanList from "./NewLoanList"

const NewLoan = (props:any) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<any>(false);
    const [editId, setEditId] = useState<any>();
    const [newLoanList, setNewLoanList] = useState<any>();
    const [open, setOpen] = useState<any>();
    const [editValue, setEditValue] = useState<any>();
    const [sort, setSort] = useState(false);
    // const [searchData, setSearchData] = useState<any>({ bank_name: "", city_id: "", city_name: "", loan_name: "", estimated_amount_capital: "", loan_reason: "", sort: "asc", sort_by: "" });
    const intl = useIntl();
    const [confirmLoading, setConfirmLoading] = useState<any>();

    const housingCompanyList:any = [
        {
            label:"Asunto Oy Helsingin",
            value:1
        },
        {
            label:"Asunto Oy Peltopyy",
            value:2
        },
        {
            label:"Asunto Oy Ruukinlehto",
            value:3
        },
        {
            label:"Asunto Oy Siliharju",
            value:4
        },
        {
            label:"Asunto Oy Tyviraitti",
            value:5
        }
    ];


    const onFormSubmit = (values: any) => {
        setOpen(false)
        setEditId("")
        onReset()
        setEditValue("")
        // if (editId) {
        //     const updateValue = {
        //         ...values,
        //         bank_contact_status: 1,
        //         bank_contact_id: editId,
        //         city_id: editValue?.city_id,
        //         city_name: editValue?.city_name
        //     }
        //     setConfirmLoading(true);
        //     BankServices
        //         .updateBankContact(updateValue, editId)
        //         .then((response: any) => {
        //             if (response?.data?.code === 200) {
        //                 message.success(intl.formatMessage({ id: convertToObjectKeyString('bank_contact_updated_successfully') }));
        //                 getBankList();
        //                 setEditId("");
        //                 setOpen(false);
        //             }
        //             if (response?.data?.code === 500) {
        //                 message.error(response?.data?.msg);
        //             }
        //             setConfirmLoading(false);
        //         })
        //         .catch((err: any) => {
        //             setConfirmLoading(false);
        //         });
        // } else {
        //     const saveValue = {
        //         ...values,
        //         bank_contact_status: 1,
        //         city_id: (typeof editValue?.city_id === 'undefined' ? null : editValue?.city_id),
        //         city_name: (typeof editValue?.city_name === 'undefined' ? "" : editValue?.city_name)
        //     }

        //     setConfirmLoading(true);
        //     BankServices
        //         .saveBankContact(saveValue)
        //         .then((response: any) => {
        //             if (response?.data?.code === 200) {
        //                 message.success(response?.data?.msg);
        //                 getBankList();
        //                 setOpen(false);
        //             }
        //             if (response?.data?.code === 500) {
        //                 message.error(response?.data?.msg);
        //             }
        //             setConfirmLoading(false);
        //         })
        //         .catch((err: any) => {
        //             setConfirmLoading(false);
        //         });
        // }
    };

    const onReset = () => {
        form.resetFields();
    }

  return (
    <>
        <Spin spinning={loading}>
            <NewLoanList
                setOpen={setOpen}
                setEditId={setEditId}
                setEditValue={setEditValue}
                setSort={setSort}
                sort={sort}
            />
        </Spin>

        <Modal title={editId ? TranslateString('edit_new_loan') : TranslateString('create_new_loan')} open={open} footer={false} destroyOnClose closable={false}>
                <Form
                    requiredMark={false}
                    onFinish={onFormSubmit}
                    layout="vertical"
                    initialValues={{housing_company: editValue?.housing_company, loan_name: editValue?.loan_name, estimated_amount_capital: editValue?.estimated_amount_capital, loan_reason: editValue?.loan_reason }}
                >
                    <Form.Item
                        label={<><span>{TranslateString('housing_company')}</span><span className="text-danger">*</span></>}
                        name="housing_company"
                        rules={[{ required: true, message: TranslateString('please_select_housing_company') }]}
                        className="mb-1"
                    >
                        <Select
                            placeholder={TranslateString('select')}
                            showSearch
                            filterOption={(input: any, option: any) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }
                            className="w-100"
                            allowClear
                            options={housingCompanyList}
                            onChange={(val, foo) => {
                                setEditValue({
                                    ...editValue,
                                    hc_id: typeof val === "undefined" ? null : val,
                                    hc_name: typeof foo?.label === "undefined" ? "" : foo?.label
                                })
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        label={<><span>{TranslateString('name_of_the_loan')}</span><span className="text-danger">*</span></>}
                        name="loan_name"
                        rules={[{ required: true, message: TranslateString('please_enter_name_of_the_loan') }]}
                        className="mb-1"
                    >
                        <Input
                            addonBefore={TranslateString('new_loan')}
                            onChange={(event: any) => setEditValue({ ...editValue, loan_name: event.target.value })}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<><span>{TranslateString('estimated_amount_of_capital')}</span><span className="text-danger">*</span></>}
                        name="estimated_amount_capital"
                        rules={[{ required: true,
                        message: TranslateString('please_enter_number'),
                        pattern: new RegExp(/^[\d,\s]+$/) }]}
                        className="mb-1"
                    >
                        <Input
                            onChange={(event: any) => setEditValue({ ...editValue, estimated_amount_capital: event.target.value })}
                        />
                    </Form.Item>
                    <Form.Item
                        label={<><span>{TranslateString('reason_for_the_loan')}</span></>}
                        name="loan_reason"
                        rules={[{ required: false, message: TranslateString('please_enter_reason_for_the_loan')}]}
                        className="mb-1"
                    >
                        <TextArea rows={4} defaultValue="" onChange={(event: any) => setEditValue({ ...editValue, loan_reason: event.target.value })} />
                        
                    </Form.Item>
                    <div className="d-flex justify-content-end mt-2">
                        <Button htmlType="button" className="btn btn-sm btn-secondary px-4" onClick={() => {
                            setOpen(false)
                            setEditId("")
                            onReset()
                            setEditValue("")
                        }}>{TranslateString('cancel')}</Button>
                        &nbsp;
                        <Button htmlType="submit" className="btn btn-sm btn-light px-3 cu-btn-green" disabled={confirmLoading}>{confirmLoading ? TranslateString("Please Wait") : TranslateString('save')}</Button>
                    </div>
                </Form>
            </Modal>
    </>
  )
}

export default NewLoan